import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export const addAdditionalParent = async (subCategoryId: string, parentCategoryId: string) => {
  const [response, bodyOrError] = await Api.post(`sub-categories/${subCategoryId}/add-parent`, {
    parentCategoryId,
  });
  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useAddAdditionalParent = () => {
  const queryClient = useQueryClient();
  return useMutation(
    'addAdditionalParent',
    (data: { subCategoryId: string; parentCategoryId: string }) => {
      return addAdditionalParent(data.subCategoryId, data.parentCategoryId);
    },
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries(['getSubCategory', variables.subCategoryId]);
      },
    },
  );
};
